import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export const authGuard: CanActivateFn = (): Observable<boolean> => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  console.log('AuthGuard: Checking authentication status...');
  return oidcSecurityService.checkAuth().pipe(
    tap((authState) => console.log('Auth state:', authState)),
    map(({ isAuthenticated }) => {
      console.log('Is authenticated:', isAuthenticated);
      if (!isAuthenticated) {
        console.log('Not authenticated, redirecting to login');
        router.navigate(['/login']);
        return false;
      }
      console.log('User is authenticated');
      return true;
    })
  );
};
